export default __webpack_public_path__ + "static/hero-blur-587de0cf23befe1bfe2ad88a80c2eced.svg";